import React, { useState, useEffect } from "react";
import axios from "../../utils/fvAxios";
import { TextField, TextareaAutosize, Typography, Button, Box, Stack } from "@mui/material";
import Security from "./Security";
import "./Myaccount.css";
import Divider from "@mui/material/Divider";
import { useLocation } from 'react-router-dom';
import { useTranslation } from "react-i18next";
import "../../Localization/i18n";
import { getOrgType } from "../../utils/Token";
import { useCallback, useMemo } from "react";
import { useDropzone } from "react-dropzone";
import Logo from "../../Media/Upload.jpeg";
import apiinfo from "../../utils/base-uri.json";
import GetfVDateFormate from "../../utils/Genaricfunctions";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import MaskedTextField from "../../components/MaskedTextField";
import { useGlobalComponent } from '../commom/GlobalComponentProvider';
import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";
// Function to detect the image format from the Base64 string
import { HasScreenPermissions, HasPermissions, getOrgId } from '../../utils/Token';
import INFO from "../../utils/Enums.json";

import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import CloseIcon from '@mui/icons-material/Close';



export default function LocationPreference() {


  const ITEM_HEIGHT = 50;
  const ITEM_PADDING_TOP = 8;
  const MenuProps = {
    PaperProps: {
      style: {
        maxHeight: ITEM_HEIGHT * 5 + ITEM_PADDING_TOP,
        width: 200,
      },
    },
  };

  const [isLoading, setIsLoading] = useState(false);
  const [Trg, setTrg] = useState(false);
  const [Dis, setDis] = useState(false);

  const [UnitsList, setUnitsList] = useState([]);
  const [SitesList, setSitesList] = useState([]);
  const [UserId, setUserId] = useState("");
  const [UnitId, setUnitId] = useState("");
  const [SiteId, setSiteId] = useState("");


  useEffect(() => {
    axios
      .get(apiinfo.myAccounts.getAccounts)
      .then((res) => {
        if (res?.data?.responseCode == 100) {
          setUserId(res?.data?.data?.userId);
          ChangeUnits(res?.data?.data?.userBusinessUnitId);
          setSiteId(res?.data?.data?.userBusinessUnitSiteId);
        }
      })
      .catch((err) => {
        console.log(err);
      });

    axios.get("Prequalification/GetPqClientBusinessUnits?clientId=" + getOrgId())
      .then((res) => {
        setUnitsList(res?.data?.data);
      })
      .catch((err) => {
        console.log(err);
      });
  }, [Trg]);


  const ChangeUnits = (e) => {
    setUnitId(e);
    axios
      .get("Prequalification/GetClientBusinessUnitSites?buId=" + e)
      .then((resp) => {
        setSitesList(resp?.data?.data);
      })
      .catch((err) => {
        console.log(err);
      });
  }




  const RemoveSafetyRepresentative = () => {
    if (UnitId == "" || UnitId == null || SiteId == "" || SiteId == null) {
      toast.error("Please select Business Unit and Site", {
        position: "top-right",
        autoClose: 4000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
      return;
    }
    setIsLoading(true);
    setDis(true);
    axios
      .post("MyAccount/SetPreferedBUAndLocation?userId=" + UserId + "&UserBusinessUnitId=" + UnitId + "&UserBUSiteId=" + SiteId)
      .then((res) => {
        if (res?.data?.responseCode == 100) {
          toast.success(res?.data?.data, {
            position: "top-right",
            autoClose: 4000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
          });
          setIsLoading(false);
          setDis(false);
          setTrg(!Trg);
        } else {
          toast.error(res?.data?.responseMessage, {
            position: "top-right",
            autoClose: 4000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
          });
          setIsLoading(false);
          setDis(false);
        }
      })
      .catch((err) => {
        console.log(err);
        setIsLoading(false);
        setDis(false);
      });

  }


  return (
    <React.Fragment>

      <ToastContainer />

      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={isLoading}
      >
        <CircularProgress color="inherit" />
      </Backdrop>

      <div className="form" style={{ overflowX: "hidden" }}>
        <label className="personal-info-heading">
          <b>Location Preference</b>
        </label>

        <Divider
          className="mt-3"
          style={{ backgroundColor: "#575656", height: "1px" }}
        />

        <div className="row mt-4">
          <div className="col-sm-6 col-md-6 col-xl-6">
            <div className="mx-3">
              <span style={{ color: "#3E4A62" }}>
                Business Unit <small style={{ color: "red" }}>*</small>
              </span>
              <br />

              <Select
                sx={{
                  "& legend": { display: "none" },
                  "& fieldset": { top: 0 },
                  width: "320px",
                }}
                labelId="demo-multiple-name-label"
                value={UnitId || ""}
                id="demo-multiple-name"
                size="small"
                onChange={(e) => ChangeUnits(e.target.value)}
                MenuProps={MenuProps}
              >
                {UnitsList?.map((item, index) => (
                  <MenuItem key={index} title={item.value} value={item.key}>
                    {item.value}
                  </MenuItem>
                ))}
              </Select>
            </div>
          </div>

          <div className="col-sm-6 col-md-6 col-xl-6">
            <div>
              <span style={{ color: "#3E4A62" }}>Site <small style={{ color: "red" }}>*</small></span>
              <br />
              <Select
                sx={{
                  "& legend": { display: "none" },
                  "& fieldset": { top: 0 },
                  width: "320px",
                }}
                labelId="demo-multiple-name-label"
                id="demo-multiple-name"
                size="small"
                value={SiteId || ""}
                onChange={(e) => setSiteId(e.target.value)}
                MenuProps={MenuProps}
              >
                {SitesList?.map((item, index) => (
                  <MenuItem key={index} title={item.siteName} value={item.businessUnitSiteId}>
                    {item.siteName}
                  </MenuItem>
                ))}
              </Select>
            </div>
          </div>

        </div>

        <Divider
          className="mt-3"
          style={{ backgroundColor: "#575656", height: "1px" }}
        />

        <div className="row mt-3 mb-3">
          <div className="text-right">
            {HasPermissions(INFO?.Screens?.MyAccount, INFO?.ScreenPermissions?.Modify) && <Button
              variant="contained"
              color="primary"
              sx={{ padding: "15px", textTransform: "capitalize" }}
              onClick={RemoveSafetyRepresentative}
            >
              Save
            </Button>
            }
          </div>
        </div>

      </div>

    </React.Fragment>
  );
}